export function millisToDate({ millis }) {
  var date = new Date(millis);
  return date.toLocaleDateString();
}

export function isValidEmail(email) {
  return /\S+@\S+\.\S+/.test(email);
}

export function dateToMilliseconds(dateString) {
  const [day, month, year] = dateString.split("/").map(Number);
  return new Date(year, month - 1, day).getTime();
}
